/* eslint complexity: ["error", 40] */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import {Container, Fade} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import Configuration from '../config';
import {useTranslation} from 'react-i18next';
import {sponsorType} from '../constants';
import advBanner from '../images/3_pubblicita_ADV.png';
import {FaBullhorn, FaExternalLinkAlt, FaGlobeEurope, FaHandshake, FaMapMarkerAlt} from 'react-icons/fa';

const PlayerSponsor = ({
  token,
  sponsors
}) => {
  const {t} = useTranslation();
  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  const sponsorGroups = [
    {
      icon: <FaGlobeEurope aria-hidden="true"/>,
      info: t('SPONSOR_GLOBAL_INFO'),
      title: t('SPONSOR_GLOBAL'),
      type: sponsorType.global
    },
    {
      icon: <FaMapMarkerAlt aria-hidden="true"/>,
      info: t('SPONSOR_LOCAL_INFO'),
      title: t('SPONSOR_LOCAL'),
      type: sponsorType.local
    }
  ];

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear', minHeight: 1000}}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter replayer_adv_sponsor_hero replayer_adv_sponsor_hero--player" data-parallax="true">
            <div className="replayer_adv_sponsor_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp sponsor-skywork-page">
            <div className="section">
              <div className="container sponsor-skywork-shell">
                <header className="sponsor-skywork-hero">
                  <span className="sponsor-skywork-eyebrow"><FaBullhorn aria-hidden="true"/> REPLAYER ADV</span>
                  <h1>{t('SPONSOR_REPLAYER_ADV')}</h1>
                  <p>{t('SPONSOR_INFO')}</p>
                  <a className="sponsor-skywork-link" href="https://www.replayer.it/it/replayeradv-diventa-sponsor/" target="_blank" rel="noopener noreferrer">
                    {t('SPONSOR_MORE_INFO')} ReplayerAdv <FaExternalLinkAlt aria-hidden="true"/>
                  </a>
                </header>

                {sponsorGroups.map(group => {
                  const visibleSponsors = sponsors
                    .filter(s => s.sponsorType === group.type && s.image && s.image.length > 0)
                    .sort(() => Math.random() - 0.5);
                  return (
                    <section className="sponsor-skywork-section" key={group.type}>
                      <div className="sponsor-skywork-section-head">
                        <span className="sponsor-skywork-section-icon">{group.icon}</span>
                        <div><h2>{group.title}</h2><p>{group.info}</p></div>
                      </div>
                      <div className="sponsor-skywork-grid">
                        {visibleSponsors.map(s => (
                          <a key={s.uid} href={s.link || undefined} target={s.link ? '_blank' : undefined} rel="noopener noreferrer" className="sponsor-skywork-card">
                            <div className="sponsor-skywork-card-media">
                              <img src={`${Configuration.apiEndPoint}/sponsors/${s.id}/image?load=${s.image[0]}`} alt={s.name || t('LOGO')}/>
                            </div>
                            <div className="sponsor-skywork-card-footer">
                              <strong>{s.name}</strong>
                              {s.link ? <span>Scopri lo sponsor <FaExternalLinkAlt aria-hidden="true"/></span> : null}
                            </div>
                          </a>
                        ))}
                        {visibleSponsors.length === 0 ? <div className="sponsor-skywork-empty">{t('NO_SPONSORS_IN_SECTION')}</div> : null}
                      </div>
                    </section>
                  );
                })}

                <section className="sponsor-skywork-cta">
                  <div className="sponsor-skywork-cta-copy">
                    <span className="sponsor-skywork-section-icon"><FaHandshake aria-hidden="true"/></span>
                    <div>
                      <h2>{t('SPONSOR_BECOME')}</h2>
                      <p>{t('SPONSOR_BECOME_INFO')}</p>
                      <p>{t('SPONSOR_BECOME_MORE_INFO')} ReplayerAdv.</p>
                      <a href="https://www.replayer.it/it/replayeradv-diventa-sponsor/" target="_blank" rel="noopener noreferrer" className="sponsor-skywork-primary">
                        {t('SPONSOR_BECOME_BANNER_INFO')} <FaExternalLinkAlt aria-hidden="true"/>
                      </a>
                    </div>
                  </div>
                  <img src={advBanner} alt={t('SPONSOR_BECOME_BANNER_INFO')}/>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
    </Fragment>
  );
};

PlayerSponsor.propTypes = {
  token: PropTypes.string,
  sponsors: PropTypes.array
};

PlayerSponsor.defaultProps = {
  token: null,
  sponsors: []
};

const mapStateToProps = ({login: {token}, player: {sponsors}}) => ({
  token,
  sponsors
});

export default withRouter(connect(
  mapStateToProps,
  null
)(PlayerSponsor));
